import type { Dispatch } from "react";
import type { EditorAction, EditorState } from "../../editor/reducers";
import { assertTypeName } from "../../client/guards";
import { useTableRegionEditorSuspenseQuery } from "../../client/generated";
import { TableRegionUpsertForm } from "./TableRegionUpsertForm";

type Props = {
  tableAttributeId: string;
  state: EditorState;
  dispatch: Dispatch<EditorAction>;
};

export function TableRegionEditor({
  tableAttributeId,
  state,
  dispatch,
}: Props) {
  const { data } = useTableRegionEditorSuspenseQuery({
    variables: {
      tableAttributeId,
    },
  });

  const { tableAttr } = data;
  assertTypeName(tableAttr?.__typename === "TableAttribute");

  if (!state.table) {
    return null;
  }

  return (
    <TableRegionUpsertForm
      fragment={tableAttr.region}
      state={state}
      dispatch={dispatch}
    />
  );
}
